export default __webpack_public_path__ + "static/gallery-art-digital-f2fd7da0e6f1a920c2012b38adff55c0.jpg";